<template>
  <modal :title="`${platform} Imports`" size="md" ref="modal">
    <imports-table :account-id="accountId" flat />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import ImportsTable from './ImportsTable.vue';

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    ImportsTable,
    Modal,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
});
</script>
